import { motion } from 'framer-motion';
import { MoreHorizontal } from 'lucide-react';

const TabButton = ({ tab, active, accent, accentFg, onPress, testId }) => {
  const Icon = tab.icon;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onPress}
      aria-current={active ? 'page' : undefined}
      className="tap-none relative flex flex-1 flex-col items-center justify-center gap-1 py-2 min-w-0 active:scale-95 transition-transform"
    >
      <span className="relative flex h-8 w-14 items-center justify-center">
        {active && (
          <motion.span
            layoutId="bottom-tab-pill"
            transition={{ type: 'spring', stiffness: 500, damping: 40 }}
            className="absolute inset-0 rounded-full"
            style={{ backgroundColor: `${accent}26` }}
          />
        )}
        <Icon
          className="relative h-[22px] w-[22px] transition-colors duration-200"
          style={{ color: active ? accent : '#71717a' }}
          strokeWidth={active ? 2.4 : 2}
        />
        {tab.badge > 0 && (
          <span
            data-testid={`${testId}-badge`}
            className={`absolute -top-1 right-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[10px] font-bold ${accentFg}`}
            style={{ backgroundColor: accent }}
          >
            {tab.badge > 99 ? '99+' : tab.badge}
          </span>
        )}
      </span>
      <span
        className="text-[11px] font-semibold tracking-wide transition-colors duration-200 truncate max-w-full"
        style={{ color: active ? '#fafafa' : '#71717a' }}
      >
        {tab.shortLabel || tab.label}
      </span>
    </button>
  );
};

export const BottomTabBar = ({ tabs, moreTabs, activeTab, onSelect, onMore, accent, accentFg }) => {
  const moreActive = moreTabs.some((t) => t.value === activeTab);
  const moreBadge = moreTabs.reduce((sum, t) => sum + (t.badge || 0), 0);

  return (
    <nav
      data-testid="bottom-tab-bar"
      className="fixed inset-x-0 bottom-0 z-40 md:hidden pb-safe border-t border-white/[0.06]"
      style={{ backgroundColor: 'rgba(9,9,11,0.88)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)' }}
    >
      <div className="flex items-stretch px-1">
        {tabs.map((tab) => (
          <TabButton
            key={tab.value}
            tab={tab}
            accent={accent}
            accentFg={accentFg}
            active={activeTab === tab.value}
            testId={`${tab.value}-tab`}
            onPress={() => (tab.action ? tab.action() : onSelect(tab.value))}
          />
        ))}
        {moreTabs.length > 0 && (
          <TabButton
            tab={{ label: 'More', icon: MoreHorizontal, badge: moreBadge }}
            accent={accent}
            accentFg={accentFg}
            active={moreActive}
            testId="more-tab"
            onPress={onMore}
          />
        )}
      </div>
    </nav>
  );
};
